import React from 'react';
import { Link } from 'react-router-dom';
import { Stack } from '@mui/material';

import { Button, LoadingOverlay, Typography } from '@occc-app/design-system';

interface IMagicLinkAuthenticateProps {
  error: boolean;
  url: string;
}

// TODO: think about better name
const MagicLinkAuthenticate: React.FC<IMagicLinkAuthenticateProps> = ({ error, url }) => {
  if (error) {
    return (
      <Stack alignItems='center' my={10}>
        <Typography component='h2' variant='h6' paragraph>
          The link you have used is expired. Please request a new magic link and try again.
        </Typography>
        <Button color='primary' variant='contained' component={Link} to={url} role='button'>
          Go to Log in page
        </Button>
      </Stack>
    );
  }

  return <LoadingOverlay loaderSize={120} />;
};

export default MagicLinkAuthenticate;
